import '../index.css'
import { 
  NavbarComponent, 
  FooterComponent, 
  HeroComponent,
  AboutComponent,
  ServicesComponent,
  ContactComponent
} from './components/ComponentManager'

// 首頁互動功能
document.addEventListener('DOMContentLoaded', async () => {
  // 取得當前頁面類型
  const currentPage = document.documentElement.dataset.page || 'home'
  
  // 載入導航列和頁尾 (所有頁面都需要)
  const navbar = new NavbarComponent()
  const footer = new FooterComponent()
  
  await navbar.loadHTML()
  await footer.loadHTML()
  
  // 綁定導航列和頁尾事件
  navbar.bindEvents()
  footer.bindEvents()
  
  // 設定當前頁面 active 狀態
  // navbar.setActivePage(currentPage)

  // 根據頁面載入對應元件
  await loadPageComponents(currentPage)
  
  // 處理 URL 錨點（如果存在）
  handleUrlHash()
})

async function loadPageComponents(currentPage: string): Promise<void> {
  try {
    if (currentPage === 'home') {
      // 主橫幅元件
      const hero = new HeroComponent()
      await hero.loadHTML()
      hero.bindEvents()
      
      // 關於我們元件
      const about = new AboutComponent()
      await about.loadHTML()
      about.bindEvents()
      
      // 專業服務元件
      const services = new ServicesComponent()
      await services.loadHTML()
      services.bindEvents()
      
      // 聯絡我們元件
      const contact = new ContactComponent()
      await contact.loadHTML()
      contact.bindEvents()
    } else if (currentPage === 'example') {
      // 範例頁面專用邏輯
      console.log('範例頁面載入完成')
      // 可以在這裡載入範例頁面專用元件
    }
    
  } catch (error) {
    console.error('Error loading page components:', error)
  }
}

// 處理 URL 錨點
function handleUrlHash(): void {
  const hash = window.location.hash.substring(1) // 移除 # 符號
  if (hash) {
    // 延遲一點時間確保元件已載入
    setTimeout(() => {
      const targetElement = document.getElementById(hash)
      if (targetElement) {
        const offset = 80 // 導航列偏移量
        const targetPosition = targetElement.offsetTop - offset
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        })
      }
    }, 100)
  }
}
